module.exports = __webpack_public_path__ + "static/media/CTAMapPin-gray.20248f93.png";